import { Pipe, PipeTransform } from '@angular/core';
import {
    IQuotationBlock, IQuotationCost, IQuotationTravellerPrice
} from "libraries/service/resources/quotation-quotations/IQuotationsQuotation";

@Pipe({
    name: 'extractTravellerDetailCost'
})

export class ExtractTravellerDetailCostPipe implements PipeTransform {
    public transform(block: IQuotationBlock, travellerId: number): IQuotationCost {
        const travellerPrice: IQuotationTravellerPrice = block.travellerPrices
            && block.travellerPrices.find((candidatePrice: IQuotationTravellerPrice) => candidatePrice.traveller === travellerId);

        return travellerPrice && travellerPrice.cost;
    }
}

